"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styleVariables = void 0;
// (C) 2007-2020 GoodData Corporation
exports.styleVariables = {
    gdColorStateBlank: "#94a1ad",
    gdColorLink: "#6d7680",
    gdColorText: "#464e56",
    gdColorGrid: "#ebebeb",
    gdColorBackground: "#fff",
    gdColorAxisLine: "#ccd6eb",
};
//# sourceMappingURL=variables.js.map